import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import AISolutions from "@/components/AISolutions";
import CaseStudies from "@/components/CaseStudies";
import TrustBadges from "@/components/TrustBadges";
import HowWeWork from "@/components/HowWeWork";
import Services from "@/components/Services";
import GivingBack from "@/components/GivingBack";
import CoreValues from "@/components/CoreValues";
import Contact from "@/components/Contact";
import ChatBot from "@/components/ChatBot";

const Home = () => {
    const [isChatOpen, setIsChatOpen] = useState(false);

    return (
        <div className="min-h-screen bg-ink-950 text-white grain">
            <Navigation />
            <Hero />
            <TrustBadges />
            <AISolutions />
            <CaseStudies />
            <HowWeWork />
            <Services />
            <GivingBack />
            <CoreValues />
            <Contact />
            <ChatBot isOpen={isChatOpen} setIsOpen={setIsChatOpen} />
        </div>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
